var _templateObject = _taggedTemplateLiteralLoose(["\n  ", ";\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"], ["\n  ", ";\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n\n  ", ";\n"]),
    _templateObject2 = _taggedTemplateLiteralLoose(["\n      position: fixed;\n      display: block;\n      display: grid;\n      z-index: 800;\n      height: 100vh;\n      width: 100vw;\n      top: 0;\n      left: 0;\n    "], ["\n      position: fixed;\n      display: block;\n      display: grid;\n      z-index: 800;\n      height: 100vh;\n      width: 100vw;\n      top: 0;\n      left: 0;\n    "]),
    _templateObject3 = _taggedTemplateLiteralLoose(["\n      overflow: hidden;\n    "], ["\n      overflow: hidden;\n    "]),
    _templateObject4 = _taggedTemplateLiteralLoose(["\n      overflow: auto;\n    "], ["\n      overflow: auto;\n    "]),
    _templateObject5 = _taggedTemplateLiteralLoose(["\n      opacity: 0;\n      transform: scale(0.6);\n    "], ["\n      opacity: 0;\n      transform: scale(0.6);\n    "]),
    _templateObject6 = _taggedTemplateLiteralLoose(["\n      transition: all 400ms cubic-bezier(0.6, -0.6, 0.125, 1.65);\n      transform: scale(1);\n      border-radius: 0;\n      opacity: 1;\n    "], ["\n      transition: all 400ms cubic-bezier(0.6, -0.6, 0.125, 1.65);\n      transform: scale(1);\n      border-radius: 0;\n      opacity: 1;\n    "]),
    _templateObject7 = _taggedTemplateLiteralLoose(["\n      transition: all 350ms cubic-bezier(0.6, -0.6, 0.125, 1.65);\n      position: fixed;\n      overflow: hidden;\n      display: block;\n      z-index: 800;\n      height: 100vh;\n      width: 100vw;\n      transform: scale(0.8);\n      top: 0;\n      left: 0;\n      opacity: 0;\n    "], ["\n      transition: all 350ms cubic-bezier(0.6, -0.6, 0.125, 1.65);\n      position: fixed;\n      overflow: hidden;\n      display: block;\n      z-index: 800;\n      height: 100vh;\n      width: 100vw;\n      transform: scale(0.8);\n      top: 0;\n      left: 0;\n      opacity: 0;\n    "]),
    _templateObject8 = _taggedTemplateLiteralLoose(["\n      transition: opacity 150ms linear;\n    "], ["\n      transition: opacity 150ms linear;\n    "]);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React, { Component } from "react";
import PropTypes from "prop-types";
import { CSSTransition } from "react-transition-group";
import styled, { css } from "styled-components";

var MainContainer = styled.div(_templateObject, function (props) {
  return props.fullScreen && css(_templateObject2);
}, function (props) {
  return props.fullScreen && !props.allowScrollbar && css(_templateObject3);
}, function (props) {
  return props.fullScreen && props.allowScrollbar && css(_templateObject4);
}, function (props) {
  return props.state === "entering" && css(_templateObject5);
}, function (props) {
  return props.state === "entered" && css(_templateObject6);
}, function (props) {
  return props.state === "exiting" && css(_templateObject7);
}, function (props) {
  return props.state === "exited" && css(_templateObject8);
});

var ReactFullScreenElement = function ReactFullScreenElement(props) {
  return React.createElement(
    "div",
    null,
    React.createElement(
      CSSTransition,
      {
        "in": props.fullScreen,
        appear: true,
        classNames: "_fullscreen-transition",
        timeout: props.fullScreen ? 50 : 350
      },
      function (state) {
        return React.createElement(
          MainContainer,
          {
            fullScreen: props.fullScreen,
            allowScrollbar: props.allowScrollbar,
            state: state
          },
          props.children
        );
      }
    )
  );
};

ReactFullScreenElement.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.any,
  fullScreen: PropTypes.bool,
  allowScrollbar: PropTypes.bool
} : {};

export default ReactFullScreenElement;